var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mt-swipe',{attrs:{"auto":4000}},_vm._l((_vm.imgList),function(item){return _c('mt-swipe-item',{key:item.id},[_c('img',{attrs:{"src":item.img}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }